import moment from 'moment';
import React, { Ref, forwardRef, useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import './style.css';

type DatePickerProps = {
    onChange: Function;
    onBlur?: Function;
    value: Date | null | undefined;
    placeholder?: string;
    disabled?: boolean;
    ref?:any;
    id?:string;
    
};

type InputProps = {
    onClick: Function;
}

const CustomInput = forwardRef(({ onClick}: InputProps, ref: any) => (
    <>
    <div className="icon small-icon calendar pointer" onClick={(e: any)=>onClick(e)}></div>
        {/* <button 
            className="custom-input" 
            ref={ref}
            onClick={(e: any)=>onClick(e)}>
            Click
        </button> */}
    </>
)
);


const CompDatePicker = (props: DatePickerProps) => {
    const DateInputRef = React.createRef<any>();
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [dateStr, setDateStr] = useState<string>('');

    
    const handleChange = (date: Date) => {
        setStartDate(date);
        setDateStr(moment(date).format('DD/MM/YYYY'));
        //console.log('CompDatePicker handleChange', date, typeof date);
        props.onChange(date);
    }
    const onClick = (date: any) => {
        //console.log('CompDatePicker onClick', date, typeof date);
    }
    const onDateInputFocus = () => {
        const nonDateCharacters = /[^0-9]/g;
        const newValue = dateStr.replace(nonDateCharacters, '');
        setDateStr(newValue);
    }
    const onDateInputBlur = () => {
        const nonDateCharacters = /[^0-9]/g;
        const newValue = dateStr.replace(nonDateCharacters, '');
        setDateStr(newValue);
        if (/^\d{8}$/.test(newValue)) {
            // console.error("Invalid input format. Expected 'DDMMYYYY'.");
            // return null;
            const date = convertDDMMYYYYToDate(newValue);
            setDateStr(moment(date).format('DD/MM/YYYY'));
            setStartDate(date);
            if(props.onBlur){
                console.log('onBlurOwnerCustomerData-onDateInputBlur', date)
                props.onBlur(date);
            }
            
        }else {
            if(props.onBlur){
                console.log('onBlurOwnerCustomerData-onDateInputBlur', newValue)
                props.onBlur(newValue);
            }
        }
    }
    
    const onDateInputChange = (e: any) => {
        //console.log('CompDatePicker onDateInputChange', e.target.value);
        let newValue = e.target.value;
        setDateStr(newValue);
        const nonDateCharacters = /[^0-9]/g;
        newValue = newValue.replace(nonDateCharacters, '');
        console.log('onDateInputChange-newValue', newValue)
        // //console.log('CompDatePicker onDateInputChange', newValue, newValue.length );
        if (newValue.length <= 8) {
            // //console.log('CompDatePicker onDateInputChange', newValue, newValue.length );
            setDateStr(newValue);
            if (/^\d{8}$/.test(newValue)) {
                // //console.log('CompDatePicker onDateInputChange has 8 chars', newValue, newValue.length );
                const date = convertDDMMYYYYToDate(newValue);
                setDateStr(moment(date).format('DD/MM/YYYY'));
                setStartDate(date);
                props.onChange(date);
                
                DateInputRef.current.blur();
            } else {
                if (newValue.length == 0) {
                    props.onChange(null);
                }
                //console.log('CompDatePicker onDateInputChange no has 8 chars', newValue, newValue.length );
            }
        }
    }

    const convertDDMMYYYYToDate = (input: string): Date | null => {
        // Check if the input string is valid
        if (!/^\d{8}$/.test(input)) {
        console.error("Invalid input format. Expected 'DDMMYYYY'.");
        return null;
        }
    
        // Extract day, month, and year from the input string
        const day = parseInt(input.slice(0, 2), 10);
        const month = parseInt(input.slice(2, 4), 10) - 1; // Months are zero-indexed in JavaScript Date
        const year = parseInt(input.slice(4, 8), 10);
    
        // Create and return the Date object
        const date = new Date(year, month, day);
    
        // Optional: Validate the created date to ensure it's correct
        if (date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day) {
        console.error("Invalid date components.");
        return null;
        }
    
        return date;
    }

    useEffect(()=>{
        //console.log('CompDatePicker props changed', props);
        if (props.value && moment(props.value).isValid()) {
            setStartDate(moment(props.value).toDate());
            setDateStr(moment(props.value).format('DD/MM/YYYY'));
        }else {
            //console.log('CompDatePicker props changed invalid', props);
            setDateStr('');
            setStartDate(null);
        }
    }, [props.value])

    // useEffect(()=>{
    //     console.log('CompDatePicker startDate changed', startDate, typeof(startDate));
    // },[startDate])

    return (
        <div className={`comp-date-picker-row ${props.disabled ? 'disabled': ''}`}>
            <input type='text' className='date-input-value' ref={DateInputRef}
                value={dateStr}
                placeholder={props.placeholder}
                onFocus={onDateInputFocus}
                onBlur={onDateInputBlur}
                disabled={props.disabled}
                onChange={onDateInputChange} />
            <DatePicker
                selected={startDate}
                disabled={props.disabled}
                onChange={handleChange}
                onSelect={handleChange}
                customInput={<CustomInput onClick={onClick} />}
                ref={props.ref}
                id={props.id}
            />
        </div>
    )
}
export default CompDatePicker;

